export default {
  'stepId': '',
  'isPassed': '10',
  'errormessage': '',
  'comment': '',
  'textAnswer': '',
  'selectedOptionId': '',
  'mOptionIds': [],
  'pictureMultipleOptionIds': [],
  'mTextAnswer': {},
  'photos': [],
  'videos': [],
  'records': [],
  'qrcodes': []
}



// WEBPACK FOOTER //
// ./src/views/question-editor/format/recovery-fields/answer.js